module.exports = __webpack_public_path__ + "static/img/11.77389f8c.jpg";